export default "__VITE_ASSET__Bt2tLRdy__"